import type {
    SiteAnalyticsSummaryScaffoldConfig,
} from '@client/app/feature-modules/site-analytics/types/site-analytics-summary-scaffold.type';

export const TRAFFIC_SOURCES_SUMMARY_PAGE_CONFIG: SiteAnalyticsSummaryScaffoldConfig = {
    mode: 'sources',
    pageHeaderKey: 'siteAnalytics.summary.sources.header',
    pageSubheaderKey: 'siteAnalytics.summary.sources.subheader',
    dateRangeLabelKey: 'siteAnalytics.scaffold.dateRange.label',
    emptyStateLabelKey: 'siteAnalytics.summary.shared.emptyState',
    sourcesMetricsLabelKey: 'siteAnalytics.summary.sources.metrics.label',
    sourcesChartTitleKey: 'siteAnalytics.summary.sources.chart.title',
    sourcesReferringSectionTitleKey: 'siteAnalytics.summary.sources.referringSectionTitle',
    sourceTopKeywordsTitleKey: 'siteAnalytics.summary.sources.topKeywords.title',
    sourcesMetricOptions: [
        {
            value: 'visits',
            labelKey: 'siteAnalytics.summary.sources.metrics.visits',
        },
        {
            value: 'uniqueVisits',
            labelKey: 'siteAnalytics.summary.sources.metrics.uniqueVisits',
        },
        {
            value: 'pageViews',
            labelKey: 'siteAnalytics.summary.sources.metrics.pageViews',
        },
        {
            value: 'avgVisitTime',
            labelKey: 'siteAnalytics.summary.sources.metrics.avgVisitTime',
        },
        {
            value: 'bounceRate',
            labelKey: 'siteAnalytics.summary.sources.metrics.bounceRate',
        },
    ],
    sourceSeries: [
        {
            id: 'organic',
            labelKey: 'siteAnalytics.summary.sources.series.searchEngine',
            color: '#57BCDB',
        },
        {
            id: 'direct',
            labelKey: 'siteAnalytics.summary.sources.series.directVisits',
            color: '#57B754',
        },
        {
            id: 'referring',
            labelKey: 'siteAnalytics.summary.sources.series.referringVisits',
            color: '#EAA646',
        },
        {
            id: 'social',
            labelKey: 'siteAnalytics.summary.sources.series.socialVisits',
            color: '#9500AC',
        },
        {
            id: 'paid',
            labelKey: 'siteAnalytics.summary.sources.series.campaignVisits',
            color: '#D24747',
        },
    ],
    sourceReferrerCards: [
        {
            id: 'externalReferringDomains',
            titleKey: 'siteAnalytics.summary.sources.referring.externalReferringDomains',
            overviewLinkLabelKey: 'siteAnalytics.summary.sources.referring.externalReferringDomainsOverview',
            overviewState: 'base.customer.domain.statistics.sources.domains',
        },
        {
            id: 'searchEngines',
            titleKey: 'siteAnalytics.summary.sources.referring.searchEngines',
            overviewLinkLabelKey: 'siteAnalytics.summary.sources.referring.searchEnginesOverview',
            overviewState: 'base.customer.domain.statistics.sources.searchEngines',
        },
        {
            id: 'socialNetworks',
            titleKey: 'siteAnalytics.summary.sources.referring.socialNetworks',
            overviewLinkLabelKey: 'siteAnalytics.summary.sources.referring.socialNetworksOverview',
            overviewState: 'base.customer.domain.statistics.sources.social',
        },
    ],
};
